import React from 'react';

// STYLES
import { HamburgerButtonWrapper, HamburgerButtonContent } from './style';

interface IHamburgerButton {
  onClick: () => void;
  isOpen: boolean;
}

export default function HamburgerButton({ isOpen, onClick }: IHamburgerButton): JSX.Element {
  return (
    <HamburgerButtonWrapper onClick={onClick} type="button" aria-label="Mostrar ou esconder o menu">
      <HamburgerButtonContent isOpen={isOpen} />
      <HamburgerButtonContent isOpen={isOpen} />
      <HamburgerButtonContent isOpen={isOpen} />
    </HamburgerButtonWrapper>
  );
}
